import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

const logoACTotal = "https://cdn.actotal.com/assets/logos/ACTLogoDark.svg";

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="Landing">
      <header className="Landing-header">
        <img src={logoACTotal} className="Landing-logo" alt="logo" />
        <p> Challenge ACTotal </p>
        <p className="Landing-link" onClick={() => navigate("/home")}>
          Go Home
        </p>
      </header>
    </div>
  );
}

export default LandingPage;
